import { Field } from "../Layout/Field";

import { Input } from "@/components/ui/input";

interface MaxToolCallsFieldProps {
  maxCalls: string;
  onMaxCallsChange: (value: string) => void;
}

export const MaxToolCallsField = ({ maxCalls, onMaxCallsChange }: MaxToolCallsFieldProps) => (
  <Field label="Tool call limit">
    <Input
      value={maxCalls}
      onChange={event => onMaxCallsChange(event.target.value)}
      inputMode="numeric"
    />
  </Field>
);
